define('../app/fukit/behavior/show.modal.on.unsaved.changes.behavior',['require','exports','module','./show.modal.on.navigate.with.unsaved.changes.behavior'],function(require, exports, module) {
  var ShowModalOnNavigateWithUnsavedChangesBehavior = require('./show.modal.on.navigate.with.unsaved.changes.behavior');
  module.exports = ShowModalOnNavigateWithUnsavedChangesBehavior;
});

